export const VennEvents = {
  invitationSent: 'invitation-sent',
  functionalCookiesAccepted: 'functional-cookies-accepted',
  advertisingCookiesAccepted: 'advertising-cookies-accepted',
  intercomAvailabilityResolved: 'intercom-availability-resolved',
  transitioned: 'transitionend',
};
